module.exports = __webpack_public_path__ + "static/connect_to_xero-120a420e62c55bc1319b2b832a62d914.png";